module.exports = __WEBPACK_EXTERNAL_MODULE_26__;


//////////////////
// WEBPACK FOOTER
// external "oasi-bpm-rest"
// module id = 26
// module chunks = 0